/**
 * /frontend/src/features/analytics/constants/datePresets.js
 */

import { addDays, toIsoDate } from '../utils/dateUtils';

/**
 * Date presets used by analytics filters.
 */
export const DATE_PRESETS = [
  {
    key: 'today',
    label: 'Today',
    resolve: () => {
      const today = new Date();
      return { startDate: toIsoDate(today), endDate: toIsoDate(today) };
    }
  },
  {
    key: 'yesterday',
    label: 'Yesterday',
    resolve: () => {
      const today = new Date();
      const yesterday = addDays(today, -1);
      return { startDate: toIsoDate(yesterday), endDate: toIsoDate(yesterday) };
    }
  },
  {
    key: '7d',
    label: 'Last 7 days',
    resolve: () => {
      const today = new Date();
      return { startDate: toIsoDate(addDays(today, -6)), endDate: toIsoDate(today) };
    }
  },
  {
    key: '30d',
    label: 'Last 30 days',
    resolve: () => {
      const today = new Date();
      return { startDate: toIsoDate(addDays(today, -29)), endDate: toIsoDate(today) };
    }
  }
];
